/**
 * This utility checks if a given value has more than 15 significant digits.
 * We restrict the number of significant digits to 15 in Submitter in case the input number loses the precision.
 *
 * It first removes leading zeros and converts the value to a string.
 * If the value is in scientific notation, it returns false.

 * It then counts the significant digits in the value.
 * If the number of significant digits is more than 15, it returns false.
 * Otherwise, it returns true.
 *
 * @param {string | number} value - The value to check.
 * @returns {boolean} - Returns true if the value has 15 or fewer significant digits, false otherwise.
 */

const isValidDigits = (value: string | number) => {
  // Remove leading zeros
  const num = typeof value === 'number' ? value : parseFloat(value);

  const numStr = num.toString();

  // Check if the converted number is in exponential notation.
  // It will have the notation when it's equal to / greater than 10^21.
  if (numStr.indexOf('e') !== -1) {
    return false;
  }

  const significantDigits = numStr.replace(/[.-]/g, '').length;

  // Check if the number of significant digits is more than 15
  return significantDigits <= 15;
};

export default isValidDigits;
